define(['angular'], function(angular) {


    function AgentProvider() {
        let bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                /**
                 * Search an agent
                 * @param  {String} search NIM or lastName
                 * @return {Promise}
                 */
                self.searchAgent = function searchAgent(search) {
                    return $http.get(bdcUrl + 'agents/search?search=' + search).then(function(res) {
                        return res.data;
                    });
                };

                self.getAnAgent = function(id) {
                    return $http.get(bdcUrl + 'agent/?id=' + id).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Create or update a client
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.createUpdate = function createUpdate(data) {
                    return $http.post(bdcUrl + 'agent/createOrUpdate', data).then(function(res) {
                        return res.data;
                    });
                };

                self.getDistinctActivities = function() {
                    return $http.get(bdcUrl + 'agents/activities', null).then(res => {
                        return res.data;
                    });
                };

                self.getDistinctTypes = function() {
                    return $http.get(bdcUrl + 'agents/types', null).then(res => {
                        return res.data;
                    });
                };

                /**
                 * Delete a contract
                 * @param  {int} id
                 * @return {Promise}
                 */
                self.deleteExperience = function(id) {
                    return $http
                        .delete(bdcUrl + 'agent/delete/experience/' + id)
                        .then(function(res) {
                            return res.data;
                        })
                        .catch(err => {
                            err.data.message = err.description;
                            return { info: err.data, id: id };
                        });
                };

                return self;
            }
        ];
    }

    angular.module('app.kya.list.agentProvider', []).provider('agent', AgentProvider);
});
